module.exports = __webpack_public_path__ + "img/medium_cup.b9c6957d.svg";